module.exports = __webpack_public_path__ + "static/media/y.d59be49c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/y.mp3
// module id = 114
// module chunks = 0